import { Card, Col, Row, Typography } from 'antd';
import { NA_PLACEHOLDER_TEXT } from '../../../../common/constants';
import { LABEL_TEXT } from '../../../../common/labelTexts';
import { JurisdictionDetailsProps } from '../graphql/clients.type';
const { Text } = Typography;

const JurisdictionDetails = ({ details, title }: JurisdictionDetailsProps) => {
  return (
    <Card className="mb-24 pl-8 pr-8">
      <Text className="heading mb-16">{title}</Text>
      <Row gutter={[16, 16]} className="mt-16">
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.AREA_CODE}</Text>
          <Text className="value">
            {details?.areaCd || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.AO_TYPE}</Text>
          <Text className="value">
            {details?.aoType || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.AO_NUMBER}</Text>
          <Text className="value">
            <span className="text-size-12">
              {details?.aoNo || NA_PLACEHOLDER_TEXT}
            </span>
          </Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="mt-16">
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.RANGE_CODE}</Text>
          <Text className="value">
            {details?.rangeCd || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.JURISDICTION}</Text>
          <Text className="value">
            {details?.aoPplrName || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
        <Col xs={8} xl={8} className="d-grid">
          <Text className="title">{LABEL_TEXT.EMAIL_ID}</Text>
          <Text className="value">
            {details?.aoEmailId || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="mt-16">
        <Col xs={24} lg={24} xl={24} className="d-grid">
          <Text className="title">{LABEL_TEXT.BUILDING_NAME}</Text>
          <Text className="value">
            {details?.aoBldgDesc || NA_PLACEHOLDER_TEXT}
          </Text>
        </Col>
      </Row>
    </Card>
  );
};

export default JurisdictionDetails;
